import { render, staticRenderFns } from "./GenericFieldPopup.vue?vue&type=template&id=4adeb617&scoped=true&"
import script from "./GenericFieldPopup.vue?vue&type=script&lang=js&"
export * from "./GenericFieldPopup.vue?vue&type=script&lang=js&"
import style0 from "./GenericFieldPopup.vue?vue&type=style&index=0&id=4adeb617&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adeb617",
  null
  
)

export default component.exports